import React from 'react';
import Helmet from 'react-helmet';
import { Fade } from 'react-reveal';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import config from '../../config/SiteConfig';
import SEO from '../components/SEO/SEO';
import Footer from '../components/Footer/Footer';
import Container from '../components/Container/Container';
import Hero from '../components/Hero/hero';
import styles from './page.module.scss';

const Page = () => {
  return (
    <div className="container project-container">
      <Helmet title={`${config.siteTitle}`} />
      <div className={styles.headerWrapper} style={{ color: `white`, marginTop: `0` }}>
        <Hero cover="../pictures/sella/hero.jpg" title="Sella Chair" link="#content" />
      </div>
      <div style={{ display: `flex`, flexDirection: `row` }}>
        <p id="content" style={{ width: `30%`, marginLeft: `18%` }}>
          The Sella Chair is a technology demonstrator designed to put to the test Digital Architects’ wood-carbon
          composites, known as “Active Grid Monocoque System” (AGM System). It showcases the complete package from
          Digital Architects’ vision, their successful use of
        </p>
        <p style={{ width: `30%`, marginRight: `18%` }}>
          Altair’s HyperWorks structural design and optimization software suite, coupled with hands-on engineering and
          proving of manufacturing processes, by evaluating the structural performance along on a scale that is closer
          to architectural requirements.
        </p>
      </div>
      <img src="../pictures/sella/first.jpg" alt="Construction of the Sella Chair" style={{ width: `100%` }}/>
      <img src="../pictures/sella/diagram.jpg" alt="Diagrams explaining the Chair"/>
      <div style={{ display: `flex`, flexDirection: `row`, marginTop: `3%` }}>
        <p id="content" style={{ width: `30%`, marginLeft: `18%` }}>
          The Sella Chair is made of Digital Architects’ AGM system wood-carbon composites: a laminated structure
          comprising of thin wood veneers, with layers of carbon fiber interspersed between them
        </p>
        <p style={{ width: `30%`, marginRight: `18%` }}>
          all adhesively-bonded together: a classic påly-wood-type construction, but with a modern twist provided by an
          advanced composite reinforcement to enhance structural performance.
        </p>
      </div>
      <img
        src="../pictures/sella/second.jpg"
        alt="Construction of the chair on a workbench"
        style={{ width: `100%` }}
      />
      <Footer />
    </div>
  );
}
export default Page;




// WEBPACK FOOTER //
// ./src/pages/sella.jsx